module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-534.959acb5.woff2";